var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8334 0C16.2936 0 16.6667 0.373092 16.6667 0.833333V5.41667C15.5161 5.41667 14.5834 6.34942 14.5834 7.50001C14.5834 8.65059 15.5161 9.58334 16.6667 9.58334V14.1667C16.6667 14.6269 16.2936 15 15.8334 15H0.833333C0.3731 15 0 14.6269 0 14.1667V9.58334C1.15059 9.58334 2.08333 8.65059 2.08333 7.50001C2.08333 6.34942 1.15059 5.41667 0 5.41667V0.833333C0 0.373092 0.3731 0 0.833333 0H15.8334ZM15 1.66667H1.66667V4.14L1.79658 4.20756C2.91206 4.81754 3.68357 5.97792 3.74592 7.32351L3.75 7.50001C3.75 8.92017 2.96056 10.1559 1.79658 10.7924L1.66667 10.8592V13.3333H15V10.8592L14.8701 10.7924C13.7546 10.1824 12.9831 9.02209 12.9208 7.67651L12.9167 7.50001C12.9167 6.07984 13.7061 4.84406 14.8701 4.20756L15 4.14V1.66667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.4fd686687055fc2939795b1b717d6596.svg";
export { ForwardRef as ReactComponent };